'use client'

import cn from 'classnames'
import './Pagination.scss'
import ReactPaginate from 'react-paginate'
import { Icon } from '@/app/src/shared/ui/Icon'

export type IProps = {
  className?: string
  currentPage?: number
  lastPage?: number
  onChange: (val: number) => void
}

const Pagination = ({ className, currentPage, lastPage, onChange }: IProps) => {
  const isPrevDisabled = Number(currentPage) === 1
  const isNextDisabled = Number(currentPage) === Number(lastPage)

  const handleChange = (selected: number) => {
    onChange(Number(selected))
  }

  const handlePrevPage = () => {
    if (isPrevDisabled) return

    handleChange(Number(currentPage) - 1)
  }

  const handleNextPage = () => {
    if (isNextDisabled) return

    handleChange(Number(currentPage) + 1)
  }

  return (
    <div
      className={cn('pagination', {
        [`${className}`]: !!className,
      })}
    >
      <button disabled={isPrevDisabled} onClick={handlePrevPage}>
        <Icon width={20} height={20} name="arrows/arrow-left" />
        <span>Previous</span>
      </button>

      <div className="pagination__container">
        <ReactPaginate
          forcePage={Number(currentPage) - 1}
          previousLabel={<div />}
          nextLabel={<div />}
          breakLabel={<span>...</span>}
          breakClassName={'dots'}
          pageCount={Number(lastPage)}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          onPageChange={({ selected }) => handleChange(Number(selected) + 1)}
          containerClassName={'pagination__list'}
          activeClassName={'active'}
          disableInitialCallback
        />
      </div>

      <button disabled={isNextDisabled} onClick={handleNextPage}>
        <span>Next</span>
        <Icon width={20} height={20} name="arrows/arrow-right" />
      </button>
    </div>
  )
}

export default Pagination
